import { useMemo } from 'react';
import {
    defineBlock,
    BlockWrapper,
    smartProps,
    useEditor,
    ChildrenBlock,
    useInspectorControl,
} from '@smartfire/js-block-engine';
import Inspector from './inspector';
import { EditableImg } from '@smartfire/components';
import { motion } from 'framer-motion';
import clsx from 'clsx';
import style from './style.module.scss';

function Block({ reverseCols, withMargin, imageSize }) {
    useInspectorControl(Inspector);
    const { isEditing } = useEditor();

    const gridColumns = useMemo(() => {
        if (reverseCols) {
            return imageSize + '% ' + (100 - imageSize) + '%';
        } else {
            return 100 - imageSize + '% ' + imageSize + '%';
        }
    }, [imageSize, reverseCols]);

    return (
        <BlockWrapper.Div
            className={clsx(
                'block-image-content',
                style.block,
                reverseCols && style.reverseCols,
                withMargin && style.withMargin,
            )}
            style={{ gridTemplateColumns: gridColumns }}
        >
            <ChildrenBlock
                className={style.children}
                gutenbergEditorConfig={{
                    orientation: 'horizontal',
                    allowedBlocks: [
                        'smartfire/button',
                        'smartfire/spacer',
                        'core/list',
                        'core/paragraph',
                        'core/heading',
                    ],
                    template: [
                        ['core/heading', { level: 3 }],
                        ['smartfire/spacer', { height: 19, mobileHeight: 1 }],
                        ['core/paragraph', {}],
                        ['smartfire/spacer', { height: 29, mobileHeight: 10 }],
                        ['smartfire/button', { text: 'Découvrir', align: 'left' }],
                    ],
                }}
            />
            <div className={style.image}>
                <motion.div
                    initial={{ transform: isEditing ? '' : reverseCols ? 'translateX(100%)' : 'translateX(-100%)' }}
                    whileInView={{ transform: 'translateX(0%)' }}
                    transition={{ duration: 0.3, ease: 'easeOut' }}
                    viewport={{ once: true }}
                />
                <motion.div
                    initial={{ transform: isEditing ? '' : reverseCols ? 'translateX(100%)' : 'translateX(-100%)' }}
                    whileInView={{ transform: 'translateX(0%)' }}
                    transition={{ delay: 0.6, duration: 0.3, ease: 'easeOut' }}
                    viewport={{ once: true }}
                >
                    <EditableImg smartProp="image" />
                </motion.div>
            </div>
        </BlockWrapper.Div>
    );
}

export default defineBlock({
    Block,
    smartProps: {
        image: smartProps.image,
        reverseCols: smartProps.bool.withDefault(false),
        withMargin: smartProps.bool.withDefault(false),
        imageSize: smartProps.number.withDefault(50),
    },
    setup: {
        title: 'Image content',
    },
});
